import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
} from "@mui/material";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import blogFetch from "../../../axios/config";
import MaterialForm from "./MaterialForm";
import { Modal } from "react-bootstrap";
import BuffeTable from "./BufferTable";
import PartFlow from "./PartFlow";
import AdditionalInformation from "./AdditionalInformation";
import SalesOrders from "./SalesOrders";
import Context from "../../../context/Context";
import language from '../../../nls/language.json';
import InfoPendency from "./components/InfoPendency";
import "./Ficha.css";
import { SimilarParts } from "./SimilarParts";
import FornosTable from "./FornosTable";

export default function Ficha(props) {
  const [headerObj, setHeaderObj] = useState(props.data);
  const [pendencia, setPendencia] = useState({});
  const {
    selectedCountry,
  } = useContext(Context);

  const {
    loadingFicha,
    idStep,
    partFlowObj,
    getMaterialForm,
    pecasObj,
    setPecasObj,
    glassLotObj,
    setGlassLotObj,
    moldesObj,
    setmoldesObj,
    toolMasurementsObj,
    materialFormObj,
    bufferObj,
    SalesOrdersObj,
    showmodalIMG,
    setShowmodalIMG,
    toolTipText,
    setToolTipText,
    statusPendencia,
    setStatusPendencia,
    showModalFicha,
    setShowModalFicha,
    setInfoPiece,
    similarParts,
    getFornosHitorico,
    fornoObj
  } = useContext(Context);

  let url = "https://ingsglass.file.core.windows.net/ingsglass/BRASIL/";
  let token =
    "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwlacupitfx&se=2033-05-04T04:42:27Z&st=2023-05-03T20:42:27Z&spr=https,http&sig=DBpnOqlwSWJgqZgPjRm5uCJ%2BgUIWicQ5cKPNhUQfNWI%3D";
  let imgName = headerObj._Plano + ".jpg";

  useEffect(() => {
    getOpenPendencias();
    setInfoPiece(`${headerObj.ordem} - ${headerObj.peca} - ${headerObj.desc_Veiculo}`);

  }, [headerObj, statusPendencia]);

  useEffect(() => {
    setPecasObj(props.data);
    setGlassLotObj(props.data);
    setmoldesObj(props.data);
    getMaterialForm();
  }, []);

  useEffect(() => {
    return () => {
      setStatusPendencia(false);
    }
  }, []);

  const getOpenPendencias = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_Pendencias/open/${headerObj.ordem}`);
      if (data) {
        setPendencia(data);
        setStatusPendencia(true);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const noInformation = () => {
    return (
      <h2 style={{ textAlign: "center", marginBottom: 10 }}>
        {language[selectedCountry.name].Dashboard.pecasSetor.ficha.semInformacoes}
      </h2>
    );
  }

  const tableView = () => {
    if (loadingFicha) {
      return (
        <div className="loadingFicha-container">
          <center>
            <FontAwesomeIcon icon={faSpinner} spin />
          </center>
        </div>
      );
    }

    console.log(Object.keys(fornoObj).length)

    switch (idStep) {
      case 1:
        return partFlowObj === {} ? noInformation() :
          <PartFlow sagA_PartFlow={partFlowObj} />
      case 2:
        return partFlowObj === {} ? noInformation() : (
          <>
            <AdditionalInformation
              data={props.data}
              sagA_Pecas={pecasObj}
              sagA_Tool={toolMasurementsObj}
              sagA_GlassLot={glassLotObj}
              sagA_MoldesGalgas={moldesObj}
            />
          </>
        )
      case 3:
        return bufferObj === {} || bufferObj.sagA_Buffers === null ? noInformation() :
          <BuffeTable sagA_Buffers={bufferObj} />
      case 4:
        return materialFormObj === {} ? noInformation() :
          <MaterialForm sagA_material={materialFormObj} />
      case 5:
        return materialFormObj === {} ? noInformation() :
          <SalesOrders
            sagA_SalesOrders={SalesOrdersObj}
            setCode={props.setCode}
            setToolTipText={setToolTipText}
          />
      case 8:
        return materialFormObj === {} ? noInformation() :
          <SimilarParts similarParts={similarParts}  />
      case 9:
        return Object.keys(fornoObj).length === 0 || fornoObj === {} ? noInformation() :
          <FornosTable  fornoObj={fornoObj} />       
    }
  };


  const modalIMG = () => {
    return (
      <Modal
        show={showmodalIMG}
        scrollable
        size="xl"
        onHide={() => setShowmodalIMG(false)}
        fullscreen="lg-down"
      >
        <Modal.Header closeButton>
          <Modal.Title> {language[selectedCountry.name].Dashboard.pecasSetor.ficha.imagem.title}:  {headerObj._Plano}</Modal.Title>
        </Modal.Header>
        <Modal.Body
        >
          <div>
            <img
              src={url + imgName + token}
              width="100%"
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const modal = () => {
    return (
      <Modal show={showModalFicha} onHide={() => {
        setToolTipText("Vazio");
        setShowModalFicha(false);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.modal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{toolTipText}</p>
        </Modal.Body>
      </Modal>
    );
  };

  const handleInfomacoes = () => {
    setShowModalFicha(true)
  }


  return (
    <>


      {statusPendencia && <InfoPendency data={pendencia} />}
      {/* <Grid container className="d-flex justify-content-center">
        <Grid xs={3} sm={1}>
          <div className="">
            <IconButton
              variant="text"
              onClick={handleInfomacoes}
            >
              <Info
                sx={iconStyle}
                color={statusPendencia ? statusColor(pendencia) : "black"}
              />
            </IconButton>
          </div>
        </Grid>
      </Grid> */}
      {/* <Grid container className="d-flex justify-content-center">
        <CustomTextField
          label='PEÇA'
          value={`${headerObj.ordem} - ${headerObj.peca} - ${headerObj.desc_Veiculo}`}
          size='lg'
        />
      </Grid> */}
      {modalIMG()}
      {modal()}
      {tableView()}
    </>
  );
}
